enum BiomeKeyType {
	BEACH = 0,
	FOREST = 1,
	ONYX_HIGHLANDS = 2,
	FUNGI_STEEPS = 3,
	SUNSET_PRISM = 4,
}

export default BiomeKeyType
